import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';

import '@kangc/v-md-editor/lib/theme/style/github.css';



import VMdEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';

// Prism
import Prism from 'prismjs';
// highlight code
import 'prismjs/components/prism-json';
import createKatexPlugin from '@kangc/v-md-editor/lib/plugins/katex/cdn';
import createAlignPlugin from '@kangc/v-md-editor/lib/plugins/align';
import createLineNumbertPlugin from '@kangc/v-md-editor/lib/plugins/line-number/index';
import createEmojiPlugin from '@kangc/v-md-editor/lib/plugins/emoji/index';
import '@kangc/v-md-editor/lib/plugins/emoji/emoji.css';
import createCopyCodePlugin from '@kangc/v-md-editor/lib/plugins/copy-code/index';
import '@kangc/v-md-editor/lib/plugins/copy-code/copy-code.css';
import createMermaidPlugin from '@kangc/v-md-editor/lib/plugins/mermaid/cdn';
import '@kangc/v-md-editor/lib/plugins/mermaid/mermaid.css';
import createTodoListPlugin from '@kangc/v-md-editor/lib/plugins/todo-list/index';
import '@kangc/v-md-editor/lib/plugins/todo-list/todo-list.css';




VMdEditor.use(vuepressTheme, {
  Prism,
});
VMdEditor.use(createKatexPlugin());
VMdEditor.use(createAlignPlugin());
VMdEditor.use(createLineNumbertPlugin());
VMdEditor.use(createEmojiPlugin());
VMdEditor.use(createCopyCodePlugin());
VMdEditor.use(createMermaidPlugin());
VMdEditor.use(createTodoListPlugin());
VMdPreview.use(vuepressTheme, {
  Prism,
});
VMdPreview.use(createKatexPlugin());
VMdPreview.use(createAlignPlugin());
VMdPreview.use(createLineNumbertPlugin());
VMdPreview.use(createEmojiPlugin());
VMdPreview.use(createCopyCodePlugin());
VMdPreview.use(createMermaidPlugin());
VMdPreview.use(createTodoListPlugin());
createApp(App).use(store).use(router).use(ElementPlus).use(VMdPreview).use(VMdEditor).mount('#app');
